/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import TextEditor from '../../../elements/formElements/TextEditor';
import axios from '../../../services/MyAxios';
import { CASINO_TOURNAMENTS } from '../Helpers/CrmUrls';

TournamentForm.defaultProps = {
    tournamentId: 0,
};

function TournamentForm({ tournamentId, handleSubmit, errors }) {
    const history = useHistory();
    const [tournament, setTournament] = useState({
        name: '',
        currency_code: process.env.MIX_CURRENCY,
        slug: '',
        short_description: '',
        description: '',
        language_id: 1,
        translation_id: 1,
        image_path: '',
        amount: 0.0,
        available_from: '',
        available_until: '',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const [languages, setLanguages] = useState([]);
    const [translations, setTranslations] = useState([]);

    useEffect(() => {
        getLanguages();
        getTranslations();
    }, []);

    if (tournamentId !== 0) {
        useEffect(() => {
            const url = `/crea/casino/api/tournaments/${tournamentId}`;
            axios
                .get(url)
                .then((response) => {
                    setTournament(response.data);
                })
                .catch((error) => {
                    if (error.response.status && error.response.status === 404) {
                        history.push({
                            pathname: CASINO_TOURNAMENTS,
                        });
                    }
                });
        }, []);
    }

    function handleFieldChange(e) {
        const { value, name } = e.target;

        setTournament({
            ...tournament,
            [name]: value,
        });
    }

    function hasErrorFor(field) {
        return !!errors[field];
    }

    function renderErrorFor(field) {
        if (hasErrorFor(field)) {
            return (
                <span className="invalid-feedback d-block">
                    <strong>{errors[field][0]}</strong>
                </span>
            );
        }

        return '';
    }

    function convertBase64(file) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = () => {
                resolve(fileReader.result);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    }

    async function handleImageChange(event) {
        const file = event.target.files[0];
        const base64 = await convertBase64(file);

        setTournament({
            ...tournament,
            image_base64: base64,
        });
    }

    function getLanguages() {
        axios.get('/crea/api/languages').then((response) => {
            setLanguages(response.data);
        });
    }

    function getTranslations() {
        axios.get('/crea/casino/api/tournaments/translations').then((response) => {
            setTranslations(response.data);
        });
    }

    const handleShortDescriptionChange = (text) => {
        setTournament({ ...tournament, short_description: text });
    };

    const handleDescriptionChange = (text) => {
        setTournament({ ...tournament, description: text });
    };

    return (
        <div className="card">
            <div className="card-body">
                <form>
                    <div className="form-group">
                        <label htmlFor="name">
                            Name <span className="text-danger text-sm">*</span>
                            <input
                                id="name"
                                type="text"
                                className={`form-control ${hasErrorFor('name') ? 'is-invalid' : ''}`}
                                name="name"
                                value={tournament.name}
                                onChange={handleFieldChange}
                            />
                        </label>
                        {renderErrorFor('name')}
                    </div>

                    <div className="form-group">
                        <label htmlFor="slug">
                            Slug <span className="text-danger text-sm">*</span>
                            <input
                                id="slug"
                                type="text"
                                className={`form-control ${hasErrorFor('slug') ? 'is-invalid' : ''}`}
                                name="slug"
                                value={tournament.slug}
                                onChange={handleFieldChange}
                            />
                        </label>
                        {renderErrorFor('slug')}
                    </div>
                    <div className="form-group">
                        <label htmlFor="amount">
                            Amount <span className="text-danger text-sm">*</span>
                            <input
                                id="amount"
                                type="number"
                                className={`form-control ${hasErrorFor('amount') ? 'is-invalid' : ''}`}
                                name="amount"
                                min={1}
                                value={tournament.amount}
                                onChange={handleFieldChange}
                            />
                        </label>
                        {renderErrorFor('amount')}
                    </div>

                    <div className="form-group">
                        <label htmlFor="language_id">
                            Language <span className="text-danger text-sm">*</span>
                            <select
                                id="language_id"
                                className={`form-control ${hasErrorFor('language') ? 'is-invalid' : ''}`}
                                name="language_id"
                                value={tournament.language_id || 1}
                                onChange={handleFieldChange}
                            >
                                {languages.map((lang) => (
                                    <option key={lang.name} value={lang.id}>
                                        {lang.name}
                                    </option>
                                ))}
                            </select>
                        </label>
                        {renderErrorFor('language_id')}
                    </div>

                    <div className="form-group">
                        <label htmlFor="translation_id">
                            This is translation of <span className="text-danger text-sm">*</span>
                            <select
                                id="translation_id"
                                className={`form-control ${hasErrorFor('translation_id') ? 'is-invalid' : ''}`}
                                name="translation_id"
                                value={tournament.translation_id || 0}
                                onChange={handleFieldChange}
                            >
                                {translations.map((translation) => (
                                    <option key={translation.name} value={translation.id}>
                                        {translation.name}
                                    </option>
                                ))}
                            </select>
                        </label>
                        {renderErrorFor('translation_id')}
                    </div>

                    <div className="form-group">
                        <label htmlFor="short_description">
                            Short description <span className="text-danger text-sm">*</span>
                            <input
                                type="hidden"
                                className={`form-control hidden ${
                                    hasErrorFor('short_description') ? 'is-invalid' : ''
                                }`}
                            />
                            <TextEditor
                                id="short_description"
                                name="short_description"
                                value={tournament.short_description}
                                onEditorChange={handleShortDescriptionChange}
                                className={`form-control
                                        ${hasErrorFor('short_description') ? 'is-invalid' : ''}`}
                            />
                        </label>
                        {renderErrorFor('short_description')}
                    </div>

                    <div className="form-group">
                        <label htmlFor="description">
                            Description <span className="text-danger text-sm">*</span>
                            <input
                                type="hidden"
                                className={`form-control hidden ${hasErrorFor('description') ? 'is-invalid' : ''}`}
                            />
                            <TextEditor
                                id="text"
                                name="text"
                                value={tournament.description}
                                onEditorChange={handleDescriptionChange}
                                className={`form-control
                                        ${hasErrorFor('description') ? 'is-invalid' : ''}`}
                            />
                        </label>
                        {renderErrorFor('description')}
                    </div>

                    <div className="form-group">
                        <label className="d-block" htmlFor="available_from">
                            Available from:
                            <span className="text-danger text-sm">*</span>
                            <input
                                id="available_from"
                                type="datetime-local"
                                className={`form-control ${hasErrorFor('available_from') ? 'is-invalid' : ''}`}
                                min={new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(':'))}
                                name="available_from"
                                value={tournament.available_from}
                                onChange={handleFieldChange}
                            />
                        </label>
                        {renderErrorFor('available_from')}
                    </div>
                    <div className="form-group">
                        <label className="d-block" htmlFor="available_until">
                            Available until:
                            <span className="text-danger text-sm">*</span>
                            <input
                                id="available_until"
                                type="datetime-local"
                                className={`form-control ${hasErrorFor('available_until') ? 'is-invalid' : ''}`}
                                min={new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(':'))}
                                name="available_until"
                                value={tournament.available_until}
                                onChange={handleFieldChange}
                            />
                        </label>
                        {renderErrorFor('available_until')}
                    </div>

                    <div className="form-group">
                        <img
                            src={tournament.image_path}
                            style={{ maxWidth: '100px', height: 'auto' }}
                            alt="current icon"
                        />
                        <label htmlFor="image_base64">
                            Image in .png format: <br />
                            <input
                                className="form-control"
                                type="file"
                                accept=".png"
                                name="image_base64"
                                onChange={handleImageChange}
                            />
                        </label>
                        {renderErrorFor('image_base64')}
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                            handleSubmit(tournament);
                        }}
                    >
                        Save
                    </button>
                </form>
            </div>
        </div>
    );
}

export default TournamentForm;
